import { render, staticRenderFns } from "./CommandCreate.vue?vue&type=template&id=8a2db0aa&"
import script from "./CommandCreate.vue?vue&type=script&lang=js&"
export * from "./CommandCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CommandCreate.vue"
export default component.exports